/* Design Studio, Letter tab: make the font control tell the truth.

   The Modern / Robot Written switch offered the same four serif faces either
   way, and the letter preview never changed. Now the switch swaps the list, and
   whichever face is chosen is applied to the preview, the signature line and
   the Reset-position sample, so what you pick is what you see.

   Every font here is already loaded by the page head, so nothing extra is
   fetched. */
(function () {
  var MODERN = [
    ['Lora', 'Lora'],
    ['Playfair Display', 'Playfair Display'],
    ['Merriweather', 'Merriweather'],
    ['Source Serif 4', 'Source Serif']
  ];
  var ROBOT = [
    ['Kalam', 'Kalam'],
    ['Caveat', 'Caveat'],
    ['Patrick Hand', 'Patrick Hand'],
    ['Shadows Into Light', 'Shadows Into Light'],
    ['Permanent Marker', 'Permanent Marker'],
    ['Special Elite', 'Special Elite (typewriter)']
  ];

  var sel, letter, mode = 'modern';
  var chosen = { modern: 'Lora', robot: 'Kalam' };

  function stack(name) {
    return mode === 'robot'
      ? "'" + name + "', 'Kalam', cursive"
      : "'" + name + "', 'Lora', Georgia, serif";
  }

  function apply() {
    if (!letter) return;
    var face = stack(chosen[mode]);
    var body = letter.querySelector('.ds2-ltxt');
    var foot = letter.querySelector('.ds2-lfoot');
    if (body) body.style.fontFamily = face;
    if (foot) foot.style.fontFamily = face;
    /* Handwriting runs small and tight at the same point size, so give it a
       little more room rather than leaving it looking cramped. */
    if (body) {
      body.style.lineHeight = mode === 'robot' ? '1.75' : '';
      body.style.letterSpacing = mode === 'robot' ? '.01em' : '';
    }
  }

  function fill() {
    if (!sel) return;
    var list = mode === 'robot' ? ROBOT : MODERN;
    sel.innerHTML = '';
    for (var i = 0; i < list.length; i++) {
      var o = document.createElement('option');
      o.value = list[i][0];
      o.textContent = list[i][1];
      o.style.fontFamily = "'" + list[i][0] + "', sans-serif";
      sel.appendChild(o);
    }
    sel.value = chosen[mode];
    if (!sel.value) { sel.selectedIndex = 0; chosen[mode] = sel.value; }
  }

  function setMode(next) {
    mode = next === 'robot' ? 'robot' : 'modern';
    fill();
    apply();
  }

  function boot() {
    sel = document.getElementById('dsTypeface');
    letter = document.getElementById('dsLetter');
    if (!sel || !letter) return;

    var buttons = document.querySelectorAll('[data-font]');
    for (var i = 0; i < buttons.length; i++) {
      (function (b) {
        b.addEventListener('click', function () {
          for (var k = 0; k < buttons.length; k++) buttons[k].classList.remove('on');
          b.classList.add('on');
          setMode(b.getAttribute('data-font'));
        });
        if (b.classList.contains('on')) mode = b.getAttribute('data-font') === 'robot' ? 'robot' : 'modern';
      })(buttons[i]);
    }

    sel.addEventListener('change', function () {
      chosen[mode] = sel.value;
      apply();
    });

    fill();
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* The Design Studio panel is revealed on demand, so run once more after the
     page has settled in case the controls were not present at first paint. */
  window.addEventListener('load', function () { setTimeout(boot, 500); });
})();
